export enum ZapModal {
  Approval = "zap__approval",
  ChangeOwner = "zap__changeOwner",
  Delete = "zap__delete",
  Duplicate = "zap__duplicate",
  Export = "zap__export",
  Move = "zap__move",
  MoveProjectAsset = "zap__moveProjectAsset",
  MoveToSharedFolderConfirmation = "zap__moveToSharedFolderConfirmation",
  Rename = "zap__rename",
}
